import { render, staticRenderFns } from "./PartnerLogin.vue?vue&type=template&id=8b253226&scoped=true"
import script from "./PartnerLogin.vue?vue&type=script&lang=js"
export * from "./PartnerLogin.vue?vue&type=script&lang=js"
import style0 from "./PartnerLogin.vue?vue&type=style&index=0&id=8b253226&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b253226",
  null
  
)

export default component.exports